import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const HalfCircle = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="82" viewBox="0 0 82 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M41.0604 0.199997H0.536926C0.536926 0.271997 0.536926 0.344955 0.536926 0.416955C0.536926 22.6477 18.8297 40.9405 41.0604 40.9405C63.2912 40.9405 81.584 22.4307 81.584 0.199997H41.0604Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
